import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Offer } from './offer';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { OfferType } from '../types';
import { ProductType } from '../types';
import { OfferOptionType } from '../types';
import { I18nValueType } from '../types';

const _schema = {
    "name": "OFFERPRODUCT",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "offer", type: "objid" },
        { name: "product", type: "objid" },
        { name: "grouped", type: "number" },
        { name: "menuctg", type: "objid" }
    ],
    relate: [
        { direction: ">", target: "OFFER", by: "offer", name: "offer", reason: "offer", child: false, class: OfferType },
        { direction: ">", target: "I18NVALUE", by: "menuctg", name: "menuctg", reason: "menuctg", child: true, class: I18nValueType },
        { direction: ">", target: "PRODUCT", by: "product", name: "product", reason: "product", child: false, class: ProductType },
        { direction: "<", target: "OFFERPRODUCTOPT", by: "product", name: "option", reason: "options", child: true, class: OfferOptionType }
    ]
} as const;

const _OfferProductClass = CreateObject(_schema);
if (!_OfferProductClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class OfferProduct extends _OfferProductClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): OfferProduct {
        return this._Copy(store) as OfferProduct;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'offer' && related instanceof Offer){
            if (related === this.offer){
                related.AddProduct(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/
    
    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.offer){
            if ((this.status == 'DE') && !this.Commited){
                this.offer.DelProduct(this);
            }
            else {
                this.offer.DoRefresh(this.table);
            }    
        }
    }    
    
    get grouped(): number {
        return this['__base__grouped'] || 0;
    }

    set grouped(value: number){
        this['__base__grouped'] = value;
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }    
}
